'use client'

import { useResolvedCompanyCtx } from '@contexts/ResolvedCompanyContext/ResolvedCompanyProvider'
import { ApplicationGuide, OrderButton } from '@segments/Guide'
import { useLayoutIsXS } from '@segments/Responsive/client'
import { BaseHeaderContent, CompanyHero, CompanyImageCard } from '@segments/ScreenLayout'
import * as React from 'react'

import { isDefined } from '~logic/helpers/isDefined'
import { Box, Grid } from '~ui/components/layout/Box'
import { Text } from '~ui/components/typography/Text/Text'
import { TSpace } from '~ui/styleGuide/spaces'

import { ValidateOrderStatus } from '../../contexts/ValidateOrderStatus/ValidateOrderStatus'

type TProps = NoChildren

export const HomeScreen: React.FC<TProps> = () => {
  const isMobile = useLayoutIsXS()

  const { resolvedBranch } = useResolvedCompanyCtx()

  const hasPromoHeader = isDefined(resolvedBranch.promoHeaderText)

  const headerPadding: TSpace = isMobile
    ? `medium` //
    : { horizontal: `extraLargePlus`, vertical: `large` }

  return (
    <CompanyImageCard minHeight={`100dvh`}>
      <Grid minHeight={`inherit`} gridTemplateRows={`1fr auto 1fr`}>
        <BaseHeaderContent padding={headerPadding} alignSelf={`start`} />
        <Grid margin={`auto`} justifyContent={`center`} alignItems={`center`} gap={`largePlus`}>
          <CompanyHero hasDescription />

          {hasPromoHeader && (
            <Box width={`100vw`} bgColor={`bgColors.primary`} padding={`medium`}>
              <Text textAlign={`center`}>{resolvedBranch.promoHeaderText}</Text>
            </Box>
          )}

          <Grid
            justifyItems={`center`}
            justifyContent={`center`}
            gap={`mediumLarge`}
            gridAutoFlow={isMobile ? `row` : `column`}
          >
            <OrderButton />
            <ApplicationGuide />
            <ValidateOrderStatus />
          </Grid>
        </Grid>
        <Box />
      </Grid>
    </CompanyImageCard>
  )
}
